import api from "@/api";

export const registerService = {
  async registar(nome, email, password) {
    const { data } = await api.post("/auth/registar", { nome, email, password });
    return data;
  },

  async verificarEmail(email, codigo) {
    const { data } = await api.post("/auth/verificar-email", { email, codigo });
    return data;
  },

  async reenviarCodigo(email) {
    const { data } = await api.post("/auth/reenviar-codigo", { email });
    return data;
  },

  async getPlanos() {
    const { data } = await api.get("/auth/planos");
    return data;
  },

  async guardarOnboarding(payload) {
    const { data } = await api.post("/auth/onboarding", payload);
    return data;
  },
};
